import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { compose } from "recompose";
import { Query, withApollo } from "react-apollo";
import ProductSpecGroupForm from "../components/table/ProductSpecGroupForm";
import productSpecGroupQuery from "../graphql/queries/productSpecGroup";

class ProductSpecGroupFormPageWithData extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired
    }),
    match: PropTypes.shape({
      params: PropTypes.shape({
        productSpecGroupId: PropTypes.string
      })
    }),
    productSpecGroupId: PropTypes.string,
    shopId: PropTypes.string.isRequired
  }

  get productSpecGroupId() {
    const { match } = this.props;
    return (match && match.params.productSpecGroupId) || null;
  }

  handleCreate = (tag) => {
    this.props.history.push(`/product-spec-groups/${tag._id}`);
  }

  handleCancel = () => {
    this.props.history.push("/product-spec-groups");
  }

  render() {
    const { client, shopId } = this.props;

    // Id there's a tagId param, then try to find
    // that tag and render the edit form
    if (this.productSpecGroupId) {
      return (
        <Query query={productSpecGroupQuery} variables={{ productSpecGroupId: this.productSpecGroupId }} fetchPolicy="network-only">
          {({ data }) => {
            const productSpecGroup = data && data.productSpecGroup;

            // Render the edit tag form
            return (
              <ProductSpecGroupForm
                client={client}
                shopId={shopId}
                productSpec={productSpecGroup}
                onCancel={this.handleCancel}
              />
            );
          }}
        </Query>
      );
    }

    // Render the create tag form
    return (
      <ProductSpecGroupForm
        client={client}
        shopId={shopId}
        onCancel={this.handleCancel}
        onCreate={this.handleCreate}
      />
    );
  }
}

export default compose(
  withApollo,
  withRouter
)(ProductSpecGroupFormPageWithData);
